export const rootPath = '';
export const RoutePaths = {
    METAVERSEMIX: `/metaversemix`,
    METAVERSEMIX_UPTOWN: `/metaversemix/uptown`,
    METAVERSEMIX_MIDTOWN: `/metaversemix/midtown`,
};
